import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import validate from 'validate.js';
import _ from 'underscore';
import compose from 'recompose/compose';
import validators from 'common/validators';

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Button, TextField, CircularProgress } from '@material-ui/core';

// Shared components
import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
  PortletFooter
} from 'components';

import { updateUser } from "../../../../actions/authActions";

// Component styles
import styles from './styles';
import schema from './schema';

validate.validators.checked = validators.checked;

class Account extends Component {
  state = {
    values: {
      name: this.props.auth.user.name,
      email: this.props.auth.user.email,
    },
    touched: {
      name: false,
      email: false,
    },
    errors: {
      name: null,
      email: null,
    },
    isValid: false,
    loading: false
  };

  validateForm = _.debounce(() => {
    const { values } = this.state;

    const newState = { ...this.state };
    const errors = validate(values, schema);

    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    this.setState(newState);
  }, 300);

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };

    newState.touched[field] = true;
    newState.values[field] = value;

    this.setState(newState, this.validateForm);
  };

  handleSave = async () => {
    try {
      const { values } = this.state;
      this.setState({loading:true});
      await this.props.updateUser(values);
      this.setState({loading:false});
      window.alert('Profile saved');
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { classes, className, ...rest } = this.props;
    const {
      values,
      touched,
      errors,
      isValid,
      loading
    } = this.state;

    const showNameError =
      touched.name && errors.name ? errors.name[0] : false;
    const showEmailError =
      touched.email && errors.email ? errors.email[0] : false;
    const rootClassName = classNames(classes.root, className);

    return (
      <Portlet
        {...rest}
        className={rootClassName}
      >
        <PortletHeader>
          <PortletLabel
            title="Profile"
          />
        </PortletHeader>
        <PortletContent noPadding>
          <form
            autoComplete="off"
            noValidate
          >
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="Name"
                margin="dense"
                required
                value={values.name}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                helperText={showNameError && errors.name[0]}
                onChange={event =>
                  this.handleFieldChange('name', event.target.value)
                }
              />
            </div>
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="Email Address"
                margin="dense"
                required
                value={values.email}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                helperText={showEmailError && errors.email[0]}
                onChange={event =>
                  this.handleFieldChange('email', event.target.value)
                }
              />
            </div>
          </form>
        </PortletContent>
        <PortletFooter className={classes.portletFooter}>
        {loading ? (
          <CircularProgress className={classes.progress} />
        ) : (
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleSave}
            disabled={!isValid}
          >
            Save profile
          </Button>
        )}
        </PortletFooter>
      </Portlet>
    );
  }
}

Account.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps,{updateUser})
)(Account);